module.exports = __webpack_public_path__ + "img/logo-evo.9d02636b.png";